var map = {
	"./__tests__/workload.test": "aa72",
	"./__tests__/workload.test.ts": "aa72",
	"./catalog.cattle.io.app": "bdd8",
	"./catalog.cattle.io.app.vue": "bdd8",
	"./catalog.cattle.io.clusterrepo": "acbe",
	"./catalog.cattle.io.clusterrepo.vue": "acbe",
	"./cis.cattle.io.clusterscan": "e3b6",
	"./cis.cattle.io.clusterscan.vue": "e3b6",
	"./fleet.cattle.io.bundle": "60dc",
	"./fleet.cattle.io.bundle.vue": "60dc",
	"./fleet.cattle.io.cluster": "e0bf",
	"./fleet.cattle.io.cluster.vue": "e0bf",
	"./fleet.cattle.io.clustergroup": "66c5",
	"./fleet.cattle.io.clustergroup.vue": "66c5",
	"./fleet.cattle.io.clusterregistrationtoken": "17a7",
	"./fleet.cattle.io.clusterregistrationtoken.vue": "17a7",
	"./fleet.cattle.io.gitrepo": "ae3b",
	"./fleet.cattle.io.gitrepo.vue": "ae3b",
	"./group.principal": "f375",
	"./group.principal.vue": "f375",
	"./helm.cattle.io.projecthelmchart": "9d92",
	"./helm.cattle.io.projecthelmchart.vue": "9d92",
	"./logging.banzaicloud.io.clusterflow": "ab85",
	"./logging.banzaicloud.io.clusterflow.vue": "ab85",
	"./logging.banzaicloud.io.flow": "bb82",
	"./logging.banzaicloud.io.flow.vue": "bb82",
	"./management.cattle.io.cluster": "5f44",
	"./management.cattle.io.cluster.vue": "5f44",
	"./management.cattle.io.feature": "49b7",
	"./management.cattle.io.feature.vue": "49b7",
	"./management.cattle.io.fleetworkspace": "e4a5",
	"./management.cattle.io.fleetworkspace.vue": "e4a5",
	"./management.cattle.io.podsecurityadmissionconfigurationtemplate": "bc4d",
	"./management.cattle.io.podsecurityadmissionconfigurationtemplate.vue": "bc4d",
	"./management.cattle.io.setting": "7800",
	"./management.cattle.io.setting.vue": "7800",
	"./management.cattle.io.user": "2f61",
	"./management.cattle.io.user.vue": "2f61",
	"./monitoring.coreos.com.alertmanagerconfig": "9c9f",
	"./monitoring.coreos.com.alertmanagerconfig.vue": "9c9f",
	"./namespace": "c855",
	"./namespace.vue": "c855",
	"./node": "9139",
	"./node.vue": "9139",
	"./persistentvolume": "ba33",
	"./persistentvolume.vue": "ba33",
	"./persistentvolumeclaim": "c817",
	"./persistentvolumeclaim.vue": "c817",
	"./provisioning.cattle.io.cluster": "fdc2",
	"./provisioning.cattle.io.cluster.vue": "fdc2",
	"./rbac.authorization.k8s.io.clusterrolebinding": "c0b3",
	"./rbac.authorization.k8s.io.clusterrolebinding.vue": "c0b3",
	"./service": "81c2",
	"./service.vue": "81c2",
	"./ui.cattle.io.navlink": "aece",
	"./ui.cattle.io.navlink.vue": "aece",
	"./workload": "5c56",
	"./workload.vue": "5c56"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "63e7";